import InlineEditText from './InlineEditText';

export default InlineEditText;
